/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { TipoPraticaEventoComunicazioneDTO } from './tipo-pratica-evento-comunicazione-dto';


export interface PagedModelTipoPraticaEventoComunicazioneDTO { 
    content?: Array<TipoPraticaEventoComunicazioneDTO>;
    page?: PageMetadata;
}

